import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import {
  NurseInclusionPatient,
  NurseInclusionPatientStatus,
  nurseInclusionStatusColorMapping,
  nurseInclusionStatusTlMapping,
} from "@/models/NurseInclusionPatientModel.ts";
import { Tag } from "@/uiKit/atoms/Tag.tsx";

export type InclusionStatusColumnProps = CellContext<NurseInclusionPatient, NurseInclusionPatientStatus>;

export const InclusionStatusColumn: React.FC<InclusionStatusColumnProps> = ({ getValue }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Tag
      color={nurseInclusionStatusColorMapping(getValue())}
      label={t(nurseInclusionStatusTlMapping(getValue()))}
      className={styles.container}
    />
  );
};

const makeStyles = () => ({
  container: css({}),
});
